import React from "react";
import Select from "react-select";

import { Modal, Button, ButtonGroup, ProgressBar } from "react-bootstrap";
import Slider, { Range } from "rc-slider";
import FlipMove from "react-flip-move";

import { LineInput } from "components/Inputs/LineInput";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import AibleStep from "containers/CreateWizard/AibleStep";
import Waterfall from "components/Waterfall/Waterfall";
import HotdogChart from "components/HotdogChart/HotdogChart";

import styles from "./style.module.css";

export default class Contest extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = { showFeatures: false };
  }

  handleUpdateCostSlider(val) {
    const { updateCostSliderRatio, handleUpdateShowFeatures, updateModelIndex } = this.props;

    updateModelIndex(0);
    handleUpdateShowFeatures(false);
    return updateCostSliderRatio(val);
  }

  renderControls() {
    const { conversionGain, conversionCost, labels, updateConversionGain, updateConversionCost } = this.props;

    return (
      <div className={styles.sliderBody}>
        <LineInput
          defaultValue={conversionGain}
          onChange={(val) => updateConversionGain(val)}
          label={"Benefit of " + labels.truePositiveLabel}
          labelStyle={{
            width: "220px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "right",
            fontWeight: "400"
          }}
          inputStyle={{ width: "auto" }}
          leadingChar={"+"}
        />
        <LineInput
          defaultValue={conversionCost}
          onChange={(val) => updateConversionCost(val)}
          label={"Cost of " + labels.falsePositiveLabel}
          labelStyle={{
            width: "220px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "right",
            fontWeight: "400"
          }}
          inputStyle={{ width: "auto" }}
          leadingChar={"-"}
        />
      </div>
    );
  }

  renderSlider() {
    const { conversionGain, conversionCost, costSliderRatio, updateCostSliderRatio, swapRatio } = this.props;

    const currentRatio = conversionGain / conversionCost;

    let marks = {};

    let valIndex = -1;
    let count = 0;
    let min = undefined;
    for (const swap of swapRatio) {
      marks[count] =
        swap.direction === "CURRENT"
          ? "Current"
          : swap.direction === "LEFT"
            ? "Increase costs " + Math.ceil(currentRatio / swap.ratio) + "x"
            : "Increase benefits " + Math.ceil(swap.ratio) + "x";

      if (costSliderRatio === undefined) {
        if (swap.direction === "CURRENT") {
          valIndex = count;
        }
      }
      if (min === undefined || Math.abs(swap.ratio - costSliderRatio) < min) {
        min = Math.abs(swap.ratio - costSliderRatio);
        valIndex = count;
      }
      count++;
    }

    return (
      <div className={styles.sliderBody}>
        <div className={styles.sHolder}>
          <Slider
            min={0}
            max={swapRatio.length - 1}
            marks={marks}
            value={valIndex}
            included={false}
            onChange={(val) => this.handleUpdateCostSlider(swapRatio[val].ratio)}
            className={styles.sliderHolder}
            dots={true}
          />
        </div>
      </div>
    );
  }

  renderLabels() {
    const { hideCosts, labels, maxIteration, metrics, model, netImpactLabel, isQuickRun, isContinuous } = this.props;

    return (
      <div className={styles.labelHolder}>
        <div
          className={styles.label}
          style={{
            height: isQuickRun && !isContinuous ? "44px" : hideCosts ? "58.33px" : "35px",
            background: "rgba(89, 65, 128, 0.05)"
          }}
        >
          {isContinuous ? "Overestimate Rel. Cost" : labels.truePositiveLabel}
        </div>
        <div
          className={styles.label}
          style={{
            height: isQuickRun && !isContinuous ? "44px" : hideCosts ? "58.33px" : "35px"
          }}
        >
          {isContinuous ? "Underestimate Rel. Cost" : labels.falsePositiveLabel}
        </div>
        <div
          className={styles.label}
          style={{
            height: isQuickRun && !isContinuous ? "44px" : hideCosts ? "0px" : "35px",
            background: "rgba(89, 65, 128, 0.05)"
          }}
        >
          {labels.trueNegativeLabel}
        </div>
        <div
          className={styles.label}
          style={{
            height: isQuickRun && !isContinuous ? "44px" : hideCosts ? "0px" : "35px"
          }}
        >
          {labels.falseNegativeLabel}
        </div>
        {(isQuickRun !== true || isContinuous) && (
          <div
            className={styles.label + " " + styles.bold}
            style={{
              height: hideCosts ? "58.33px" : "35px",
              background: "rgba(89, 65, 128, 0.05)"
            }}
          >
            {isContinuous ? "Total Relative Cost" : netImpactLabel}
          </div>
        )}
        {maxIteration.improvement !== undefined && !isQuickRun && (
          <div className={styles.label + " " + styles.bold}>{"Improvement"}</div>
        )}
        {maxIteration.truePositive !== undefined && isQuickRun !== true && (
          <div className={styles.label}>{"Processed"}</div>
        )}
        {maxIteration.truePositive !== undefined && <div className={styles.label}>{labels.truePositiveLabel}</div>}
        {maxIteration.accuracy !== undefined && <div className={styles.label}>{"Accuracy"}</div>}
        {maxIteration.precision !== undefined && <div className={styles.label}>{"Precision"}</div>}
        {maxIteration.recall !== undefined && <div className={styles.label}>{"Recall"}</div>}
        {maxIteration.accuracy !== undefined && <div className={styles.label}>{"Log Loss"}</div>}
        {metrics.mean_absolute_error !== undefined && <div className={styles.label}>{"Mean Absolute Error"}</div>}
        {metrics.sum_over_predict !== undefined && <div className={styles.label}>{"Sum of Overestimates"}</div>}
        {metrics.sum_under_predict !== undefined && <div className={styles.label}>{"Sum of Underestimates"}</div>}
      </div>
    );
  }

  renderModels() {
    const {
      id,
      isDone,
      completedCount,
      runCost,
      isQuickRun,
      showFeatures,
      swapRatio,
      deployContainer,
      models,
      modelIndex,
      isWizard,
      isAzure
    } = this.props;

    let fModels = models.map((m) => m);

    if (modelIndex !== 0 && models && models.length > 0 && models.length > modelIndex + 1) {
      [fModels[1], fModels[modelIndex + 1]] = [fModels[modelIndex + 1], fModels[1]];
    }

    return (
      <div className={styles.models}>
        <div className={styles.modelSection}>
          <div className={styles.main}>
            {id === "new" ? (
              <div className={styles.emptyMsg}>{"Contest will show here after models are ran"}</div>
            ) : (
              models === undefined ||
              (models.length === 0 && (
                <div className={styles.loadingHolder}>
                  <LoadingIndicator style={{ margin: "0px" }} />
                </div>
              ))
            )}
            {models && models.length > 0 && (
              <div className={styles.mHolder}>
                <FlipMove className={styles.flipMove} duration={500}>
                  {fModels}
                </FlipMove>
                {models.length === 1 && isDone === false && (
                  <div>
                    {!isAzure && this.renderProgressBars()}
                    <div className={styles.load}>
                      <LoadingIndicator />
                    </div>
                  </div>
                )}
                {/* !isQuickRun && swapRatio && swapRatio.length > 1 && this.renderSlider( */}
                {showFeatures !== true && this.renderLabels()}
                {showFeatures === true && this.renderFeatures()}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderCostsCheck() {
    const { hideCosts, updateHideCosts } = this.props;

    return (
      <div className={styles.costsCheck} onClick={() => updateHideCosts(!hideCosts)}>
        <input type="checkbox" checked={!hideCosts} onChange={() => {}} />
        {"Include soft benefits and costs"}
      </div>
    );
  }

  renderFeatures() {
    const { features } = this.props;

    return (
      <div className={styles.features}>
        <HotdogChart bars={features} />
      </div>
    );
  }

  renderFeaturesOld() {
    const { features } = this.props;

    return (
      <div className={styles.features}>
        <div className={styles.featureSide}>
          <Waterfall
            bars={features.map((feature) => ({
              value: Number(feature.left.toFixed(2)),
              tooltipLabel: "Percentage"
            }))}
            isStacked
          />
        </div>
        <div className={styles.featureMid}>
          <Waterfall
            bars={features.map((feature) => ({
              label: feature.label,
              value: Number(feature.delta.toFixed(2)),
              tooltipLabel: "Percentage"
            }))}
            isStacked
          />
        </div>
        <div className={styles.featureSide}>
          <Waterfall
            bars={features.map((feature) => ({
              value: Number(feature.right.toFixed(2)),
              tooltipLabel: "Percentage"
            }))}
            isStacked
          />
        </div>
      </div>
    );
  }

  renderBar(startMessage, endMessasge, progress) {
    return (
      <div className={styles.progressHolder}>
        <div className={styles.startMessage}>{startMessage}</div>
        <ProgressBar now={progress} />
        <div className={styles.endMessage}>{endMessasge}</div>
      </div>
    );
  }

  renderProgressBars() {
    const { serverProgress, notebookProgress } = this.props;

    return (
      <div className={styles.barHolder}>
        {this.renderBar("Starting AWS Servers", serverProgress >= 100 ? "Server Started" : "", serverProgress)}
        {this.renderBar("Starting Notebooks", notebookProgress >= 100 ? "Notebooks Created" : "", notebookProgress)}
      </div>
    );
  }

  renderError() {
    const { errors, history } = this.props;

    return (
      <div className={styles.eHolder}>
        <div className={styles.error}>{"Error running models"}</div>
        {errors ? errors.map((e, index) => <div key={index}>{e.message}</div>) : <div />}
        <a onClick={() => history.push("/")} className={styles.homeLink}>
          {"Home"}
        </a>
      </div>
    );
  }

  render() {
    const { id, isError, handleUpdateShowFeatures, showFeatures, features, isWizard, isDone, completedCount, history } =
      this.props;

    if (isError) {
      return this.renderError();
    }

    return (
      <div className={styles.contest}>
        {isWizard && (
          <AibleStep
            id={id}
            bId="contest"
            message={
              completedCount === 0
                ? "Running... I'm looking for AIs that meet your criteria."
                : (isDone ? "AI training complete." : "Running...") +
                  " I found " +
                  completedCount +
                  " AIs that meet your criteria."
            }
            style={{ marginBottom: "20px" }}
          />
        )}
        <div className={styles.contestBody}>{this.renderModels()}</div>
      </div>
    );
  }
}
